import { Direction } from '@angular/cdk/bidi';
import { Overlay } from '@angular/cdk/overlay';
import { Component, OnInit } from '@angular/core';
import { PopUpComponent } from 'src/app/@shared/components/pop-ups/pop-up.component';
import { LanguageService } from 'src/app/@shared/services/language/language.service';
import { ResizeService } from 'src/app/@shared/services/resize/resize.service';
import { Color } from 'src/app/@shared/types/color.type';
import { CLOSE, EXACT_ARRIVAL_TIME, PLANNED_ARRIVAL_TIME, TIMES_LEGEND } from 'src/app/modules/route-planner/constants/multi-language.constants';
import { RoutePlanningService } from 'src/app/modules/route-planner/services/route-planning/route-planning.service';

@Component({
    selector: 'app-time-information',
    templateUrl: './time-information.component.html',
    styleUrls: ['./time-information.component.scss'],
    standalone: false
})
export class TimeInformationComponent extends PopUpComponent implements OnInit{
 

    override isDesktop: boolean
    timesLegendText: string
    closeText: string
    direction: Direction
    exactArrivalTimeText: string
    plannedArrivalTimeText: string

    times: {
      text: string,
      color: Color,
    }[] = []

    constructor(
      private readonly languageService: LanguageService,
      routePlanningService: RoutePlanningService,
      resizeService: ResizeService,
      overlay: Overlay,
    ){
      super(routePlanningService, resizeService, overlay);
    }

    override ngOnInit(): void {
      super.ngOnInit()
      this.isDesktop = this.resizeService.isDesktop
      this.initializeMultiLanguageTexts()
      this.times = [
        {
          text: this.exactArrivalTimeText,
          color: "rgba(0, 134, 103, 1)"
        },
        {
          text: this.plannedArrivalTimeText,
          color: "#00000"
        },
      ]

      // {
      //   text: "האוטובוס מאחר",
      //   color: "rgba(212, 40, 46, 1)"
      // },
    }

    initializeMultiLanguageTexts() {
      this.languageService.selectedLanguage$.subscribe(language => {
        this.direction = language.direction
        this.timesLegendText = TIMES_LEGEND[language.language]
        this.closeText = CLOSE[language.language]
        this.exactArrivalTimeText = EXACT_ARRIVAL_TIME[language.language]
        this.plannedArrivalTimeText = PLANNED_ARRIVAL_TIME[language.language]
      })
    }
}
